import { useCallback } from 'react';
import { useAppUpdatesContext } from '@app/app/src/AppContext';
import {
  filtersToUrlParams,
  createFilterUrlSearch,
  type FilterState,
} from '../utils/urlFilterUtils';

export interface UseBundleUrlFilterSyncReturn {
  // eslint-disable-next-line no-unused-vars
  syncFiltersToUrl: (overrides?: Partial<FilterState>) => void;
}

export const useBundleUrlFilterSync = (): UseBundleUrlFilterSyncReturn => {
  const { state } = useAppUpdatesContext();

  const syncFiltersToUrl = useCallback(
    (overrides?: Partial<FilterState>) => {
      // eslint-disable-next-line no-unused-vars
      const { committedFiltersVersion: _committedFiltersVersion, ...filters } =
        state.bundles.committedFilters;

      const currentFilters: Partial<FilterState> = {
        ...filters,
        cursor: state.bundles.pagination.cursor,
        limit: state.bundles.pagination.limit,
        ...overrides,
      };

      const urlParams = filtersToUrlParams(currentFilters);
      const searchString = createFilterUrlSearch(urlParams);
      const newUrl = `${window.location.pathname}${searchString}`;

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', newUrl);
      }
    },
    [state.bundles.committedFilters, state.bundles.pagination],
  );

  return {
    syncFiltersToUrl,
  };
};
